import React from 'react';

import { TableTBodyWrapper } from '@wp-block-builder/block-helpers/table-layout-components';
import { useLegacyTemplatesEnabled } from '@wp-block-builder/stores/WaypointDocumentStore/useGlobalStyles';

type BlockSectionWrapperProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};
export default function BlockSectionWrapper({ style, children }: BlockSectionWrapperProps) {
  const legacyTemplatesEnabled = useLegacyTemplatesEnabled();

  if (!legacyTemplatesEnabled) {
    return <div style={style}>{children}</div>;
  }
  return (
    <TableTBodyWrapper>
      <tr>
        <td style={style} align="left" valign="top">
          {children}
        </td>
      </tr>
    </TableTBodyWrapper>
  );
}
